import {createSelector} from 'helpers';
import {store} from 'store';
import {name} from 'store/common';

export const form = createSelector(
  [ state => state.identity, name ],
  ( data, name ) => ({
    initialValues: data[name],
    onChange: values => store.dispatch({
      type: 'IDENTITY_UPDATE',
      name,
      data: values,
    })
  })
);
